module.exports = function(polls) {
	'use strict'
	polls.directive('pollDir',pollDir);
	pollDir.$inject=[];
	function pollDir() {
		return {
			template: require('./partial/edit-newpoll.html'),
			controller:"pollController",
			controllerAs:"vmpl",
			link: function(scope, element, attrs, ctrl) {
				    
			}

		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/pollsModule/edit-newpoll/js/directive/pollDirective.js
// module id = 542
// module chunks = 0